import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  id?: number;
  individual_ids?: number[];
}

export const useCreateIndividualsInvites = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/mandate/${params.id}/send_invite/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
